export { default as UserMenuCompanyProfileLink } from './UserMenuCompanyProfileLink';
